import { SecondaryMarketQuotesWorkspace } from 'components/Workspaces/SecondaryMarketQuotes';

export default SecondaryMarketQuotesWorkspace;
